<template>
  <div>
  <v-card class="elevation-12">
    <v-card-text
      class="font-weight-bold red--text"
      v-show="errorMessage">
      {{ errorMessage }}
    </v-card-text>
    <v-card-text>
      <v-form>
        <v-text-field
          v-model="email"
          prepend-icon="person"
          name="login"
          label="メールアドレス"
          type="text"
          v-validate="'required|email'"
          data-vv-name="email"
          data-vv-as="メールアドレス"
          required
          :error-messages="errors.collect('email')"
        >
        </v-text-field>
        <v-text-field
          v-model="password"
          prepend-icon="lock"
          name="password"
          label="パスワード"
          type="password"
          v-validate="'required|min:6'"
          data-vv-name="password"
          data-vv-as="パスワード"
          required
          :error-messages="errors.collect('password')"
        >
        </v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
    <v-spacer></v-spacer>
      <v-btn
        color="primary"
        outlined
        rounded
        @click='signIn()'
      >ログイン
      </v-btn>
    </v-card-actions>
    <v-card-actions>
        <span
          class="caption"
          style="cursor:pointer"
          @click="passwordDialog=true"
          ><u>パスワードをお忘れの方</u>
        </span>
    </v-card-actions>
    <VProgress
      v-model="inProgress"
      :message="'ログインしています…'"
    />
  </v-card>
    <v-dialog
      :value="!verified"
      persistent
      width="520">
      <v-card>
        <v-container>
          <v-row>
            <v-col cols=auto>
              メールアドレス及び教師情報の確認が完了していません。<br>
              確認メールを再送信しますか。
            </v-col>
          </v-row>
          <v-row>
            <v-col cols=auto>
              <v-btn
                class="ma-1"
                rounded
                outlined
                @click="verified=true">
                閉じる
              </v-btn>
              <v-btn
                class="ma-1"
                rounded
                outlined
                @click="resendVerifyMail">
                再送信
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      :value="resend"
      width="400">
      <v-card>
        <v-container>
          <v-row justify="center">
            <v-col>
              メールを送信しました。
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols=auto>
              <v-btn
                class="ma-1"
                rounded
                outlined
                @click="resend=false">
                閉じる
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      :value="!profile"
      persistent
      width="520">
      <v-card>
        <v-container>
          <v-row>
            <v-col cols=auto>
              教師情報の登録をお願いします。<br>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-col cols=auto>
              <v-btn
                class="ma-1"
                rounded
                outlined
                @click="$router.push('/teacher/profile')">
                はい
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <password-reset-dialog
      v-model="passwordDialog"
      @submit-button-click="sendResetMail"
      :errMessage="errMessage"
    />
  </div>
</template>

<script>
import { firestore } from '@/repository/client/firestore.js'
import { auth } from '@/auth/client/firebase'
import { AuthService } from "@/service/auth/auth"
import PasswordResetDialog from "@/components/organisms/teacher/PasswordResetDialog.vue"
import VProgress from "@/components/organisms/VProgress.vue"

export default {
  name: 'TopLogin',
  components: {
    "password-reset-dialog": PasswordResetDialog,
    "VProgress": VProgress
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      email: '',
      password: '',
      errorMessage: "",
      errMessage: "",
      passwordDialog: false,
      dialog: false,
      verified: true,
      resend: false,
      profile: true,
      inProgress: false,
    }
  },
  methods: {
    async signIn() {
      this.inProgress = true
      const result = await this.$validator.validateAll()
      if (result) {
        try {
          const teacher = await this.authService.signInAsTeacher(this.email, this.password)
          if (teacher) {
            const uuid = teacher.uuid
            this.$store.commit('loginAsTeacher', teacher)
            this.$router.push(`/teacher/${uuid}/editors`)
          } else {
            this.profile = false
          }
        } catch(e) {
          if (e.name === 'UserUnVerifiedError') {
            this.verified = false
          } else {
            this.errorMessage = e.message
          }
        }
      }
      this.inProgress = false
    },
    async sendResetMail(email) {
      try {
        await this.authService.sendPasswordResetMail(email)
        this.passwordDialog = false
        this.resend = true
      } catch(e) {
        this.errMessage = e.message
      }
    },
    async resendVerifyMail() {
      await this.authService.sendVerifyMail(process.env.VUE_APP_TEACHER_SIGNUPED_URL)
      this.verified = true
      this.resend = true
    }
  },
  created() {
    this.authService = new AuthService(auth, firestore)
  }
}
</script>